import { useTranslation } from "i18nano";
import React, { useState } from "react";
import { Button, ModalConfirm, Input } from "../../../../components/UI";
import { useTerminalStore } from "../../../../stores";
import { ITerminal } from "../../../../types/terminals";
import { TPlaylistModal } from "../TerminalItem";
import styles from "./styles.module.scss";

interface IProps {
    terminal: ITerminal;
    showModalHandler: (mode: TPlaylistModal) => void;
}

const TerminalSettingsModal: React.FC<IProps> = ({ terminal, showModalHandler }) => {
    const t = useTranslation();
    const user_role = localStorage.getItem("user_role");
    const { unbindPlaylist, updatePlaylist, updateTerminal } = useTerminalStore(state => state);

    const [showConfirm, setShowConfirm] = useState(false);
    const [terminalName, setTerminalName] = useState(terminal.name);
    const [terminalSerialNumber, setTerminalSerialNumber] = useState(terminal.serial_number);

    const unbindPlaylistHandler = () => {
        if (terminal.binding_playlist) {
            unbindPlaylist([terminal.id]);
        }
    };

    const updateTerminalNameHandler = () => {
        updateTerminal(
            {
                id: terminal.id,
                name: terminalName,
                serial_number: terminalSerialNumber,
            }
        );
    };

    const isTerminalDataChanged = () => {
        return (terminalName && terminalName != terminal.name) 
        || (terminalSerialNumber && terminalSerialNumber != terminal.serial_number)
    };

    return (
        <div className={styles.root}>
            <div className={styles.item}>
                {
                    user_role === "admin" || user_role === "organization_admin" ?
                        <>
                            <span>{t("label.name", { name: t("terminal.genitive") })}</span>
                            <Input
                                value={terminalName}
                                onChange={setTerminalName}
                                type={"text"}
                                placeholder={t("placeholder.text", { name: t("table_head.name") })}
                            />
                            {
                                user_role === "admin" ? 
                                    <>
                                        <span>{t("label.serial_number", { name: t("terminal.genitive") })}</span>
                                        <Input
                                            value={terminalSerialNumber}
                                            onChange={setTerminalSerialNumber}
                                            type={"text"}
                                            placeholder={t("placeholder.text", { name: t("table_head.serial_number") })}
                                        />
                                    </>
                                : undefined
                            }
                            <Button variant={isTerminalDataChanged() ? "primary" : "disabled"} onClick={updateTerminalNameHandler} >{t("button.save")}</Button>
                        </>
                    : undefined
                }
            </div>
            <div className={styles.buttons_container}>
                <Button variant={!terminal.terminal_pool_name ? "primary-empty" : "disabled"} onClick={() => showModalHandler("bind")}>{t("terminal_page.terminal_settings_modal.controls.change_playlist")}</Button>
                <Button variant={terminal.binding_playlist ? "primary-empty" : "disabled"} onClick={() => window.location.href = `/playlists/edit/${terminal.binding_playlist!.playlist_id}`}>{t("terminal_page.terminal_settings_modal.controls.view_playlist")}</Button>
                <Button variant={terminal.binding_playlist && !terminal.terminal_pool_name ? "primary-empty" : "disabled"} onClick={() => updatePlaylist(terminal.id)}>{t("terminal_page.terminal_settings_modal.controls.update_playlist")}</Button>
                <Button variant={terminal.binding_playlist && !terminal.terminal_pool_name ? "danger-empty" : "disabled"} onClick={() => setShowConfirm(true)}>{t("terminal_page.terminal_settings_modal.controls.unbind_playlist")}</Button>
            </div>
            {terminal.binding_playlist
                ? <ModalConfirm isShow={showConfirm} setIsShow={setShowConfirm} onConfirm={unbindPlaylistHandler} onCancel={() => { }}>
                    {t("terminal_page.unbind_confirm.message", { name: terminal.binding_playlist.playlist_name })}
                </ModalConfirm>
                : null
            }
        </div>
    );
};

export default TerminalSettingsModal;